import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getUserInformation } from 'src/modules/user/selectors/userSelectors';
import { font } from 'src/shared/styles/variables';

const DashboardGreeting: React.FC<{}> = () => {
    const { t } = useTranslation();
    const userInformation = useSelector(getUserInformation);

    const bannerText = t('dashboard:hello', { firstName: userInformation.firstName });

    return (
        <h2
            style={{
                ...font.heavy(font.size.extraLarge),
                marginBottom: 28,
            }}
        >
            {bannerText}
        </h2>
    );
};

export default DashboardGreeting;
